import { apiClient } from '@/api/client';
import type { PaginatedResult } from '@/types/api';
import type { CreateMailboxBody, Mailbox, MailboxDomainSummary, MailboxListParams } from '@/features/mailboxes/types';

/** Mailbox management — existing mail-admin-service endpoints. */
export const mailboxesApi = {
  list: async (params: MailboxListParams): Promise<PaginatedResult<Mailbox>> =>
    (await apiClient.get<PaginatedResult<Mailbox>>('/mailboxes', { params })).data,
  get: async (id: string): Promise<Mailbox> => (await apiClient.get<Mailbox>(`/mailboxes/${id}`)).data,
  domainSummary: async (): Promise<MailboxDomainSummary[]> =>
    (await apiClient.get<MailboxDomainSummary[]>('/mailboxes/domain-summary')).data,
  create: async (body: CreateMailboxBody): Promise<Mailbox> =>
    (await apiClient.post<Mailbox>('/mailboxes', body)).data,
  update: async (id: string, body: Partial<{ displayName: string; status: string; quotaBytes: number }>): Promise<Mailbox> =>
    (await apiClient.patch<Mailbox>(`/mailboxes/${id}`, body)).data,
  remove: async (id: string): Promise<void> => { await apiClient.delete(`/mailboxes/${id}`); },
  resetPassword: async (id: string, body: { newPassword: string; revokeSessions?: boolean }): Promise<void> => {
    await apiClient.post(`/mailboxes/${id}/reset-password`, body);
  },
};
